/**
 * Converts a markdown string by replacing all occurrences of the `@familyPrice@` placeholder
 * with the default family connection plan's monthly fee (formatted as "Xkr/mån").
 *
 * The function retrieves the default family connection plan price from the family store,
 * and performs a global replacement in the input string. If the input string is empty or undefined,
 * an empty string is returned.
 *
 * @param inputString - The markdown string containing `@familyPrice@` placeholders to be replaced.
 * @returns The input string with all `@familyPrice@` placeholders replaced by the formatted price,
 *          or an empty string if no input is provided.
 */
export const convertMarkdownIntoFamilyPriceHtml = (inputString = '') => {
  const store = useFamilyStore();
  if (!inputString) {
    return '';
  }

  const defaultfamilyConnectionPlan = computed(() => {
    return store.getDefaultFamilyConnectionPlan?.bundlePrices.find(
      (x) => x.BindingPeriod.Months === 12,
    )?.Plan;
  });
  const defaultfamilyConnectionPlanPrice = computed(() => {
    return defaultfamilyConnectionPlan.value?.MonthlyFee;
  });

  const defaultfamilyConnectionPlanPriceReg = computed(() => {
    return defaultfamilyConnectionPlan.value?.RegularMonthlyFee;
  });

  let priceString =
    String(defaultfamilyConnectionPlanPrice.value ?? '') + ' kr/mån';

  if (
    defaultfamilyConnectionPlanPriceReg.value &&
    defaultfamilyConnectionPlanPriceReg.value != 0
  ) {
    priceString =
      `<span class="strike-through" >${defaultfamilyConnectionPlanPriceReg.value}</span> ` +
      String(defaultfamilyConnectionPlanPrice.value ?? '') +
      ' kr/mån';
  }

  return inputString.replaceAll(/(@familyPrice@)/g, priceString);
};
